import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export default function D() {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('solar60w');
    const IMG_SPECS_EU = ['eu', 'de', 'fr', 'it', 'es', 'kr'];

    return (
        <div className={`solar-60w-D ${css['solar-60w-D']}`}>
            <div className="text-box">
                <p className="title">{t('sec4_title')}</p>
                <p className="desc">
                    {t.rich('sec4_desc', {
                        black: (text: string) => <span className="black">{text}</span>,
                    })}
                </p>
            </div>
            <div className="img-box">
                <div className="img-top">
                    <NextImage
                        src={require(`@publicLocal/solar-60w/pc/4_1${IMG_SPECS_EU.includes(locale) ? '_eu' : locale === 'uk' ? '_uk' : ''}.jpg`)}
                        alt={t('sec4_title')}
                        aria-label={t('sec4_title')}
                    />
                </div>
                <div className="img-bottom">
                    <div className="img-b-l">
                        <NextImage src={require('@publicLocal/solar-60w/pc/4_2.jpg')} alt={t('sec4_text1')} aria-label={t('sec4_text1')} />
                        <p className="text">{t('sec4_text1')}</p>
                    </div>
                    <div className="img-b-r">
                        <div className="img-b-r-t">
                            <NextImage
                                src={require(`@publicLocal/solar-60w/pc/4_3${['us', 'ca'].includes(locale) ? '_na' : ''}.jpg`)}
                                alt={t('sec4_text2')}
                                aria-label={t('sec4_text2')}
                            />
                            <p className="text">{t('sec4_text2')}</p>
                        </div>
                        <div className="img-b-r-b">
                            <NextImage
                                src={require(`@publicLocal/solar-60w/pc/4_4${['us', 'ca'].includes(locale) ? '_na' : ''}.jpg`)}
                                alt={t('sec4_text3')}
                                aria-label={t('sec4_text3')}
                            />
                            <p className="text">{t('sec4_text3')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
